import Entity from '../entity'
import ProductFindingReply from './ProductFindingReply';

export default class ProductFinding extends Entity<number>{
    title: string = null;
    description: string = null;
    findingImageUrl: string = null;
    isFinished: boolean;
    tenantId: number = null;
    userNo: string = null;
    userAvatarImageUrl: string = null;
    userFullName: string = null;
    creationTime: string;
    remark: string  = null;
    productFindingReplies: Array<ProductFindingReply>;

}